<template>
  <div class="ai-articles-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting/ai-consulting">AI及大模型咨询</router-link>
      <span class="separator">/</span>
      <span class="current">专题文章</span>
    </nav>

    <div class="container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="page-title">AI及大模型专题文章</h1>
        <p class="page-desc">精选企业级AI与大模型实践、治理合规、行业落地等深度内容，助力企业构建AI核心竞争力。</p>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-tabs">
          <span class="filter-tab" :class="{ active: activeCategory === 'all' }" @click="activeCategory = 'all'">全部</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'strategy' }" @click="activeCategory = 'strategy'">AI战略</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'practice' }" @click="activeCategory = 'practice'">大模型实践</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'governance' }" @click="activeCategory = 'governance'">AI治理</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'industry' }" @click="activeCategory = 'industry'">行业落地</span>
          <span class="filter-tab" :class="{ active: activeCategory === 'compliance' }" @click="activeCategory = 'compliance'">合规风控</span>
        </div>
        <div class="search-box">
          <input type="text" class="search-input" placeholder="搜索文章..." v-model="searchKeyword" @keyup.enter="searchArticles">
          <button class="search-btn" @click="searchArticles">搜索</button>
        </div>
      </div>

      <!-- 文章列表 -->
      <div class="article-list">
        <div class="article-item" v-for="article in filteredArticles" :key="article.id" @click="goToArticle(article.id)">
          <div class="article-meta">
            <span class="article-date">{{ article.date }}</span>
            <div class="article-tags">
              <span class="article-tag" v-for="tag in article.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          <h2 class="article-title">{{ article.title }}</h2>
          <p class="article-summary">{{ article.summary }}</p>
          <div class="article-footer">
            <span class="read-more">阅读全文 <i class="fas fa-arrow-right"></i></span>
            <span class="article-stats"><i class="fas fa-eye"></i> {{ article.views }}</span>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <span class="page-btn" @click="changePage(currentPage - 1)"><i class="fas fa-chevron-left"></i></span>
        <span class="page-btn" v-for="p in totalPages" :key="p" :class="{ active: currentPage === p }" @click="changePage(p)">{{ p }}</span>
        <span class="page-btn next" @click="changePage(currentPage + 1)">下一页 <i class="fas fa-chevron-right"></i></span>
      </div>

      <!-- 推荐文章侧栏 -->
      <div class="sidebar">
        <h3 class="sidebar-title">热门推荐</h3>
        <ul class="recommend-list">
          <li class="recommend-item" @click="goToArticle(3)">• 大模型在制造业的应用：智能质检与预测性维护</li>
          <li class="recommend-item" @click="goToArticle(8)">• 大模型在金融风控中的应用：反欺诈与信用评估</li>
          <li class="recommend-item" @click="goToArticle(1)">• 企业私有化大模型实践：从选型到部署全流程</li>
          <li class="recommend-item" @click="goToArticle(4)">• AI合规与风险管理：算法备案、数据安全、伦理审查</li>
          <li class="recommend-item" @click="goToArticle(6)">• 企业知识库RAG实践：从文档到智能问答</li>
        </ul>
      </div>
    </div>

    <!-- 底部转化模块 -->
    <section id="contact">
      <div class="container">
        <div class="cta-section">
          <div class="cta-title">获取更多AI深度内容</div>
          <p style="font-size: 18px; margin-bottom: 30px;">订阅我们的邮件，每周获取最新AI实践文章与行业报告</p>
          <button class="btn-primary" @click="showSubscribeModal = true">立即订阅</button>
        </div>
      </div>
    </section>

    <!-- 订阅弹窗 -->
    <div class="modal-overlay" v-if="showSubscribeModal" @click.self="showSubscribeModal = false">
      <div class="modal-container">
        <span class="modal-close" @click="showSubscribeModal = false">&times;</span>
        <h3 style="margin-bottom: 20px;">订阅AI专题文章</h3>
        <form @submit.prevent="submitSubscribe">
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="姓名" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="email" placeholder="企业邮箱 *" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <div style="margin-bottom: 15px;">
            <input type="text" placeholder="公司名称" style="width:100%; padding:12px; border-radius:8px; border:1px solid #ddd;">
          </div>
          <button class="btn-primary" style="width:100%;">确认订阅</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiArticles',
  data() {
    return {
      activeCategory: 'all',
      searchKeyword: '',
      searchActive: false,
      currentPage: 1,
      showSubscribeModal: false,
      articles: [
        {
          id: 1, category: 'practice', date: '2025-04-15',
          tags: ['私有化大模型', '部署实践'],
          title: '企业私有化大模型实践：从选型到部署全流程',
          summary: '如何选择适合企业需求的基础模型？私有化部署需要哪些基础设施？本文结合能源行业案例，详细解析大模型私有化的关键步骤与避坑指南。',
          views: '1.2k阅读'
        },
        {
          id: 2, category: 'governance', date: '2025-03-28',
          tags: ['AI治理', '模型监控'],
          title: 'AI治理框架设计：从原则到可执行的体系',
          summary: 'AI治理不是空中楼阁。本文提出可落地的AI治理三支柱：组织机制、技术工具、流程规范，并介绍大型金融机构的治理实践。',
          views: '856阅读'
        },
        {
          id: 3, category: 'industry', date: '2025-03-12',
          tags: ['制造业', '工业AI'],
          title: '大模型在制造业的应用：智能质检与预测性维护',
          summary: '某汽车制造企业引入大模型进行零部件缺陷检测，准确率提升至99.3%，设备停机时间减少40%。本文详解技术方案与实施路径。',
          views: '2.1k阅读'
        },
        {
          id: 4, category: 'compliance', date: '2025-02-20',
          tags: ['合规', '算法备案'],
          title: 'AI合规与风险管理：算法备案、数据安全、伦理审查',
          summary: '随着《生成式AI服务管理暂行办法》实施，企业如何确保AI应用合规？本文梳理监管要求与应对策略，并附合规检查清单。',
          views: '1.5k阅读'
        },
        {
          id: 5, category: 'strategy', date: '2025-02-05',
          tags: ['AI战略', '央国企'],
          title: '央国企AI战略规划指南：顶层设计与落地路径',
          summary: '结合服务30+央国企的经验，提出AI战略制定的五步法：愿景设定、场景识别、能力评估、路线图规划、组织保障。',
          views: '2.3k阅读'
        },
        {
          id: 6, category: 'practice', date: '2025-01-18',
          tags: ['RAG', '知识库'],
          title: '企业知识库RAG实践：从文档到智能问答',
          summary: '如何将企业分散的文档、知识转化为可交互的智能问答系统？本文详解RAG架构设计、向量数据库选型与效果优化。',
          views: '1.8k阅读'
        },
        {
          id: 7, category: 'governance', date: '2025-01-02',
          tags: ['数据治理', 'AI就绪'],
          title: '为AI准备数据：数据治理如何支撑大模型应用',
          summary: '数据质量决定AI应用效果。本文提出"AI就绪数据治理框架"，包含数据标准、质量、安全、元数据四个维度。',
          views: '967阅读'
        },
        {
          id: 8, category: 'industry', date: '2024-12-15',
          tags: ['金融', '智能风控'],
          title: '大模型在金融风控中的应用：反欺诈与信用评估',
          summary: '某股份制银行引入大模型进行反欺诈识别，准确率提升15%，误报率下降30%。本文详解技术方案与业务价值。',
          views: '2.7k阅读'
        },
        {
          id: 9, category: 'compliance', date: '2024-11-28',
          tags: ['数据出境', '隐私计算'],
          title: 'AI时代的数据出境合规与隐私计算应用',
          summary: '随着数据跨境流动监管趋严，企业如何通过隐私计算技术实现"数据可用不可见"，满足合规要求？',
          views: '1.1k阅读'
        },
        {
          id: 10, category: 'practice', date: '2024-11-10',
          tags: ['AI Agent', '自动化'],
          title: 'AI Agent在企业业务流程自动化中的应用',
          summary: '从智能客服到流程自动化，AI Agent正在重塑企业运营。本文介绍Agent框架选型与典型应用场景。',
          views: '1.4k阅读'
        },
        {
          id: 11, category: 'strategy', date: '2024-10-22',
          tags: ['AI投资', 'ROI'],
          title: 'AI投资回报率(ROI)测算模型与案例分析',
          summary: '如何量化AI项目的价值？本文提出包含直接收益、效率提升、风险降低的三维ROI模型，并结合案例演示。',
          views: '856阅读'
        },
        {
          id: 12, category: 'governance', date: '2024-10-05',
          tags: ['模型偏见', '伦理'],
          title: 'AI伦理与偏见治理：确保大模型公平性',
          summary: '大模型可能存在的偏见如何识别与缓解？本文介绍偏见检测工具与公平性优化方法，并分享金融机构的治理实践。',
          views: '723阅读'
        }
      ]
    }
  },
  computed: {
    filteredArticles() {
      let list = this.articles
      if (this.activeCategory !== 'all') {
        list = list.filter(a => a.category === this.activeCategory)
      }
      if (this.searchActive && this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase()
        list = list.filter(a =>
          a.title.toLowerCase().includes(kw) ||
          a.summary.toLowerCase().includes(kw)
        )
      }
      return list
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredArticles.length / 6)) || 1
    }
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    searchArticles() {
      this.searchActive = true
    },
    changePage(p) {
      if (p >= 1 && p <= this.totalPages) {
        this.currentPage = p
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    goToArticle(id) {
      console.log('跳转到文章', id)
    },
    submitSubscribe() {
      alert('订阅成功！')
      this.showSubscribeModal = false
    }
  },
  watch: {
    activeCategory() {
      this.currentPage = 1
    },
    searchKeyword(val) {
      if (!val) this.searchActive = false
    }
  }
}
</script>

<style scoped>
.ai-articles-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
  z-index: 999;
  border-bottom: 1px solid rgba(31,63,143,0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,0.9);
}
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-menu-inner {
  display: flex;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
}
.nav-item-inner {
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #2B2F3A;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  background-color: transparent;
  border: none;
  white-space: nowrap;
}
.nav-item-inner:hover {
  background-color: #EAF0FB;
  color: #1F3F8F;
}
.nav-item-inner.active {
  background-color: #1F3F8F;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}

/* 页面标题 */
.page-header {
  margin-bottom: 40px;
  margin-top: 20px;
}
.page-title {
  font-size: 38px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 16px;
}
.page-desc {
  font-size: 18px;
  color: #5f6a7d;
  max-width: 800px;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
}
.filter-tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-tab {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}
.filter-tab.active, .filter-tab:hover {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.search-box {
  display: flex;
  gap: 8px;
}
.search-input {
  padding: 10px 16px;
  border-radius: 40px;
  border: 1px solid var(--border-light);
  width: 250px;
  font-size: 14px;
}
.search-btn {
  padding: 10px 24px;
  border-radius: 40px;
  background: var(--primary-blue);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.search-btn:hover {
  background: #0e3170;
}

/* 文章列表 */
.article-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-bottom: 50px;
}
.article-item {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.05);
}
.article-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}
.article-date {
  color: #5f6a7d;
  font-size: 14px;
}
.article-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.article-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  color: var(--primary-blue);
}
.article-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--deep-indigo);
  margin-bottom: 12px;
}
.article-summary {
  color: #5f6a7d;
  margin-bottom: 20px;
  line-height: 1.7;
}
.article-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.read-more {
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: gap 0.3s;
}
.article-item:hover .read-more {
  gap: 12px;
}
.article-stats {
  font-size: 14px;
  color: #8a95a8;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 60px 0;
}
.page-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.page-btn:hover, .page-btn.active {
  background: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.page-btn.next {
  width: auto;
  padding: 0 16px;
  border-radius: 40px;
}

/* 推荐文章侧栏 */
.sidebar {
  background: var(--bg-light);
  border-radius: 16px;
  padding: 24px;
  margin-top: 40px;
}
.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.recommend-list {
  list-style: none;
  padding: 0;
}
.recommend-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: color 0.3s;
}
.recommend-item:hover {
  color: var(--primary-blue);
}

/* 底部转化 */
.cta-section {
  background: var(--deep-indigo);
  border-radius: 32px;
  padding: 60px;
  color: white;
  text-align: center;
  margin: 60px 0;
}
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}
.btn-primary {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-container {
  background: white;
  border-radius: 32px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
}
.modal-close {
  float: right;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .search-box {
    width: 100%;
  }
  .search-input {
    width: 100%;
  }
  .page-title {
    font-size: 28px;
  }
}
</style>
